






































































import { Component, Prop, Vue } from "@/shared/vuepack";
import moment from "moment/moment";
import { MessageActionType, MessageCenterMessage, UpdateMessageRequest } from "@/shared/types";
import { useMessageCenterStore } from "@/employee/store/messageCenter";

@Component({})
export default class MessageDetail extends Vue {
  @Prop()
  selectedEmail: MessageCenterMessage;
  @Prop()
  isOpen: boolean;
  @Prop()
  isUpdating: boolean;

  messageCenterStore = useMessageCenterStore();
  localStorageItemName = "MessageCenter_MessageDetailWidth";
  startX = 0;
  rightWidth = 0;
  leftWidth = 0;
  currentWidth = 0;
  isResizing = false;

  mounted () {
    this.leftWidth = document.getElementById("email-list").offsetWidth;
    const widthString = localStorage.getItem(this.localStorageItemName);
    const parsedWidth = parseFloat(widthString);
    if (parsedWidth !== 0 && (parsedWidth <= this.maxWidth && parsedWidth >= this.minWidth)) {
      this.currentWidth = parsedWidth;
    } else {
      this.currentWidth = this.leftWidth * 0.5;
    }
  }

  get containerWidth () {
    return `${this.currentWidth}px`;
  }

  get minWidth () {
    return (this.rightWidth + this.leftWidth) * 0.15;
  }

  get maxWidth () {
    return (this.rightWidth + this.leftWidth) - ((this.rightWidth + this.leftWidth) * 0.45);
  }

  startResize (event) {
    const startX = event.clientX;
    const leftWidth = document.getElementById("email-list").offsetWidth;
    const startWidth = document.getElementById("email-preview").offsetWidth;
    this.startX = startX;
    this.rightWidth = startWidth;
    this.leftWidth = leftWidth;
    this.isResizing = true;
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.stopResize);
  }

  onMouseMove (event) {
    const dx = event.clientX - this.startX;
    let newWidth = this.rightWidth - dx;
    if (newWidth < this.minWidth) {
      newWidth = this.minWidth;
    }
    if (newWidth > this.maxWidth) {
      newWidth = this.maxWidth;
    }
    this.currentWidth = newWidth;
  }

  stopResize () {
    this.isResizing = false;
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.stopResize);
    localStorage.setItem(this.localStorageItemName, `${this.currentWidth}`);
  }

  formatDate (date: string) {
    return moment(date).format("MM/DD/yyyy hh:mm A");
  }

  closeEmail () {
    this.$emit("onDetailClose");
  }

  setReadValue (id: string, isRead: boolean) {
    if (!this.isUpdating) {
      this.messageCenterStore.markMessageAsRead(id, isRead);
    }
  }

  setSaveValue (id: any, value: boolean) {
    if (!this.isUpdating) {
      const request: UpdateMessageRequest = {
        messageId: id,
        isSaved: value,
        isArchived: this.selectedEmail.isArchived && value ? !value : this.selectedEmail.isArchived
      };
      this.messageCenterStore.setMessageSavedOrArchived(request, MessageActionType.Save);
    }
  }

  setArchivedValue (id: number, value: boolean) {
    if (!this.isUpdating) {
      const request: UpdateMessageRequest = {
        messageId: id,
        isArchived: value,
        isSaved: this.selectedEmail.isSaved && value ? !value : this.selectedEmail.isSaved
      };
      this.messageCenterStore.setMessageSavedOrArchived(request, MessageActionType.Archive);
    }
  }
}
